"use strict";
const mainNavigation = Array.from(document.querySelectorAll('[data-ssh-mainnavigation]'));
const documentBody = document.querySelector('body');
if (mainNavigation) {
    const createBlackoutElement = document.createElement('div');
    createBlackoutElement.classList.add('blackout');
    mainNavigation.forEach((navigation) => {
        navigation.addEventListener("click", (event) => {
            event.preventDefault();
            const el = event.target;
            if (el.classList.contains('nav-link-text')) {
                documentBody.appendChild(createBlackoutElement);
                documentBody.classList.add('no-scroll');
            }
            const blackoutElement = document.querySelector('.blackout');
            const activeMenuItems = Array.from(document.querySelectorAll('.c-subnavigation__item--active'));
            const navItem = el.closest('.nav-item');
            const currentFlyout = navItem.querySelector('.c-subnavigation');
            if (currentFlyout.classList.contains('c-subnavigation--hidden')) {
                currentFlyout.classList.remove('c-subnavigation--hidden');
                if (!navItem.classList.contains('c-subnavigation__item--active')) {
                    if (navItem.classList.contains('active')) {
                        navItem.classList.remove('active');
                    }
                    navItem.classList.add('c-subnavigation__item--active');
                }
            }
            activeMenuItems.forEach((item) => {
                item.classList.remove('c-subnavigation__item--active');
                item.querySelector('.c-subnavigation').classList.add('c-subnavigation--hidden');
                documentBody.appendChild(createBlackoutElement);
                documentBody.classList.add('no-scroll');
                // Handle click on same nav item
                if (el.closest('.nav-link').id === item.querySelector('.nav-link').id) {
                    item.classList.remove('c-subnavigation__item--active');
                    item.querySelector('.c-subnavigation').classList.add('c-subnavigation--hidden');
                    (blackoutElement) ? blackoutElement.remove() : '';
                    documentBody.classList.remove('no-scroll');
                }
            });
            if (!el.classList.contains('nav-link-text')) {
                (blackoutElement) ? blackoutElement.remove() : '';
                documentBody.classList.remove('no-scroll');
            }
            // Let users click on blacked out area to close navigation.
            if (blackoutElement) {
                blackoutElement.addEventListener("click", (event) => {
                    if (!navigation.parentElement.querySelector('.c-subnavigation').classList.contains('c-subnavigation--hidden')) {
                        navigation.parentElement.querySelector('.c-subnavigation').classList.add('c-subnavigation--hidden');
                        navigation.parentElement.classList.remove('c-subnavigation__item--active');
                        blackoutElement.remove();
                        documentBody.classList.remove('no-scroll');
                    }
                });
            }
        });
        documentBody.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                event.preventDefault();
                if (!navigation.parentElement.querySelector('.c-subnavigation').classList.contains('c-subnavigation--hidden')) {
                    navigation.parentElement.querySelector('.c-subnavigation').classList.add('c-subnavigation--hidden');
                    navigation.parentElement.classList.remove('c-subnavigation__item--active');
                    const blackoutElement = document.querySelector('.blackout');
                    (blackoutElement) ? blackoutElement.remove() : '';
                    documentBody.classList.remove('no-scroll');
                }
            }
        });
    });
}
